// Adres API. Na Cloudflare Pages ustaw REACT_APP_API_URL (np. https://stand-api.best.krakow.pl/api).
// Bez zmiennej używa /api na tej samej domenie (przekierowanie przez functions/api/[[path]].js).
export const API_URL = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

// Klucz do panelu admina: /hasiok69?key=KLUCZ (zapamiętywany w przeglądarce)
export const getAdminKey = () => {
    try {
        const fromUrl = new URLSearchParams(window.location.search).get('key');
        if (fromUrl) window.localStorage.setItem('adminKey', fromUrl);
        return fromUrl || window.localStorage.getItem('adminKey') || '';
    } catch (e) {
        return '';
    }
};
